export default "__VITE_ASSET__b564bcb9__"